var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var StackedKeyHandler = /** @class */ (function (_super) {
    __extends(StackedKeyHandler, _super);
    function StackedKeyHandler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyPress = function (event) {
            event.preventDefault();
            if (event.keyCode === _this.props.keyCode) {
                _this.props.handler(event);
            }
        };
        _this.initializeMapValue = function (key) {
            if (!StackedKeyHandler.eventStack) {
                StackedKeyHandler.eventStack = new Map();
            }
            if (!StackedKeyHandler.eventStack.has(key)) {
                StackedKeyHandler.eventStack.set(key, []);
            }
        };
        _this.pushEvent = function () {
            var key = _this.props.keyEventType;
            var stack = StackedKeyHandler.eventStack.get(key);
            if (stack.length > 0) {
                window.document.removeEventListener(key, stack[stack.length - 1]);
            }
            stack.push(_this.handleKeyPress);
            window.document.addEventListener(key, _this.handleKeyPress, false);
        };
        _this.popEvent = function () {
            var key = _this.props.keyEventType;
            var stack = StackedKeyHandler.eventStack.get(key);
            var lastEvent = stack.pop();
            window.document.removeEventListener(key, lastEvent);
            if (stack.length > 0) {
                window.document.addEventListener(key, stack[stack.length - 1], false);
            }
        };
        return _this;
    }
    StackedKeyHandler.prototype.componentDidMount = function () {
        this.initializeMapValue(this.props.keyEventType);
        this.pushEvent();
    };
    StackedKeyHandler.prototype.componentWillUnmount = function () {
        this.popEvent();
    };
    StackedKeyHandler.prototype.render = function () {
        return React.createElement(React.Fragment, null);
    };
    return StackedKeyHandler;
}(React.Component));
export { StackedKeyHandler };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/key-handler/StackedKeyHandler.tsx
// module id = 1367
// module chunks = 3